module.exports = __webpack_public_path__ + "static/media/twicces.e659acb7.png";